<ion-item>

  <ion-thumbnail slot="start">
    <img [src]="item.avatar || 'assets/img/empty-img/no_user.png'" alt="">
  </ion-thumbnail>

  <ion-label>

    <div class="title">
      @if (!item.fin) {
        <yu-badge type="dot" color="success"></yu-badge>
      }

      {{ item.usuario }}
    </div>

    <div class="time">
      <yu-icon name="clock"></yu-icon>

      <p>
        <span>{{ item.hora_inicio }}</span> a <span>{{ item.hora_fin ? item.hora_fin : '--:--' }}</span>

        @if (item.fin_next && item.diff_days > 0) {
          <sup>+{{ item.diff_days }}</sup>
        }

        @if (item.local) {
          en <span>{{ item.local }}</span>
        }
      </p>
    </div>

  </ion-label>

  @if (item.id_estado_firma !== clockInStatusEnum.notRequested) {

    <ion-note>

      <yu-tag [color]="tagManager.getColorTag(item, 'clock-in')">
        {{ item.estado_firma }}
      </yu-tag>

    </ion-note>

  }

</ion-item>
